<div class="filters">

    <div class="row chip-container">
        <icc-chip [focusable]="false" (click)="onListClick()" [class.icc-chip-elevated]="!isShowMap" class="icc-assist-chip"><icc-icon name="list"></icc-icon>{{ 'INTERFACE|Lista' | translate }}</icc-chip>
        <icc-chip [focusable]="false" (click)="onMapClick()" [class.icc-chip-elevated]="isShowMap" class="icc-assist-chip"><icc-icon name="view_map"></icc-icon>{{ 'INTERFACE|Mapa' | translate }}</icc-chip>
    </div>

    <div class="filters__name">{{ 'INTERFACE|Filtry' | translate }}</div>

    <div class="filters__filter">

        <div class="filters__filter__name">{{ 'COMPLAINT_APPOINTMENT|Przypisana osoba' | translate }}</div>

        <div class="row">

            <icc-select
                name="assignedUserId"
                [value]="assignedUserId"
                (valueChange)="handleWorkers($event)"
            >
                <option [value]="0">{{ 'INTERFACE|Dowolny' | translate }}</option>
                <option
                    *ngFor="let worker of workersList | keyvalue"
                    value="{{worker.key}}"
                >
                    {{worker.value}}
                </option>
            </icc-select>

        </div>

    </div>

    <div class="filters__filter">

        <div class="filters__filter__name">{{ 'COMPLAINT_APPOINTMENT|Podmiot przypisany' | translate }}</div>

        <div class="row">
            <ng-select
                autocomplete="off"
                [(ngModel)]="userTypeCompanyId"
                [ngModelOptions]="{standalone: true}"
                [virtualScroll]="true"
                [searchable]="true"
                [notFoundText]="'INTERFACE|Brak wyników' | translate"
                (change)="handleContractor($event)"
            >
                <ng-option [value]="0">{{ 'INTERFACE|Dowolny' | translate }}</ng-option>
                <ng-option *ngFor="let contractor of filteredContractorsList" [value]="contractor.companyId">{{getUserTypeName(contractor.userType)}} {{contractor.companyName}}</ng-option>
            </ng-select>

        </div>

    </div>

    <div class="filters__filter">

        <div class="filters__filter__name">{{ 'COMPLAINT_APPOINTMENT|Status' | translate }}</div>

        <div class="row" >

            <icc-select
                (valueChange)="onStatusChange($event)"
                [value]="status"
            >
                <option
                    *ngFor="let status of appointmentStatuses"
                    [value]="status.value"
                >
                    {{ status.label | translate }}
                </option>
            </icc-select>

        </div>
    </div>

    <div class="filters__filter">

        <div class="filters__filter__name">{{ 'COMPLAINT_APPOINTMENT|Data wizyty' | translate }}</div>

        <div class="row">

            <icc-form-field
                size="small"
            >
                <label iccLabel>{{ 'INTERFACE|Od' | translate }}</label>
                <icc-input
                    type="date"
                    name="date"
                    [value]="dateFrom"
                    (valueChange)="onDateFromChange($event)"
                >
                </icc-input>

            </icc-form-field>

        </div>

        <div class="row">

            <icc-form-field
                size="small"
            >
                <label iccLabel>{{ 'INTERFACE|Do' | translate }}</label>
                <icc-input
                    type="date"
                    [value]="dateTo"
                    (valueChange)="onDateToChange($event)"
                >
                </icc-input>

            </icc-form-field>

        </div>

    </div>

    <div class="filters__actions">
        <div class="row">
            <button iccButton appearance="secondary" (click)="emitFilters()">
                {{ 'INTERFACE|Filtruj' | translate }} <icc-icon name="navigate_next"></icc-icon>
            </button>
        </div>

        <div class="row">
            <button iccButton appearance="outline" (click)="resetFilters()">
                {{ 'INTERFACE|Resetuj' | translate }}  <icc-icon name="navigate_before"></icc-icon>
            </button>
        </div>
    </div>

</div>
